import React, { ReactElement } from 'react';

import { useKeycloak } from '@react-keycloak/web';
import LoadingComponent from '../components/Loading';
import { Redirect, Route, RouteComponentProps, RouteProps } from 'react-router-dom';

export const MY_DATA = '/meus-dados';
export const MY_LISTINGS = '/meus-anuncios';
export const MY_FAVORITES = '/meus-favoritos';
export const TERMS = '/termo-de-adesao';
export const OFFERS = '/propostas';
export const LISTING = '/anuncio';
export const PERFORMANCE = '/performance';
export const NOT_FOUND = '/404';

export const LISTING_EDIT = 'editar';

interface PrivateRouteProps extends RouteProps {
  children?: ReactElement;
  component?: React.ComponentType<RouteComponentProps> | React.ComponentType;
  shouldRedirect?: boolean;
}

export function PrivateRoute({
  children,
  component: Component,
  shouldRedirect,
  ...rest
}: Readonly<PrivateRouteProps>): ReactElement {
  const { keycloak, initialized } = useKeycloak();

  if (initialized && !keycloak.authenticated) {
    if (process.env.NODE_ENV !== 'development') {
      window.location.href = '/login';
    } else {
      keycloak.login();
    }

    return <LoadingComponent />;
  }

  if (Component && !shouldRedirect) {
    return <Route {...rest} render={props => <Component {...props} />} />;
  }

  if (shouldRedirect) {
    return (
      <Route {...rest}>
        <Redirect to={'/404'} />
      </Route>
    );
  }

  return <Route {...rest}>{children}</Route>;
}
